import api from './api'

export const authService = {
  // 用户登录
  login(credentials) {
    return api.post('/auth/signin', credentials)
  },

  // 获取当前用户信息
  getCurrentUser() {
    const user = localStorage.getItem('user')
    return user ? JSON.parse(user) : null
  },

  // 检查用户是否已登录
  isAuthenticated() {
    const user = this.getCurrentUser()
    return user && user.token
  },

  // 检查用户是否为管理员
  isAdmin() {
    const user = this.getCurrentUser()
    return user && (user.role === 'ADMIN' || user.role === '平台管理员' || user.role === '管理员')
  },

  // 检查用户是否为课程管理员
  isCourseAdmin() {
    const user = this.getCurrentUser()
    return user && user.role === '课程管理员'
  },

  isTherapyAdmin() {
    const user = this.getCurrentUser()
    return user && user.role === '理疗活动管理员'
  },

  // 登出
  logout() {
    localStorage.removeItem('user')
  },

  // 获取认证头
  getAuthHeader() {
    const user = this.getCurrentUser()
    return user && user.token ? `Bearer ${user.token}` : null
  },

  // 检查token是否即将过期（提前5分钟检查）
  isTokenExpiringSoon() {
    const user = this.getCurrentUser()
    if (!user || !user.token) return true
    
    try {
      // 解析JWT token获取过期时间
      const payload = JSON.parse(atob(user.token.split('.')[1]))
      const exp = payload.exp * 1000 // 转换为毫秒
      const now = Date.now()
      const fiveMinutes = 5 * 60 * 1000 // 5分钟
      
      return (exp - now) < fiveMinutes
    } catch (error) {
      console.error('解析token失败:', error)
      return true
    }
  },

  // 检查token是否已过期
  isTokenExpired() {
    const user = this.getCurrentUser()
    if (!user || !user.token) return true
    
    try {
      // 检查token格式是否正确
      const tokenParts = user.token.split('.')
      if (tokenParts.length !== 3) {
        console.error('Token格式不正确')
        return true
      }
      
      // 解析JWT token获取过期时间
      const payload = JSON.parse(atob(tokenParts[1]))
      if (!payload.exp) {
        console.error('Token中没有过期时间')
        return true
      }
      
      const exp = payload.exp * 1000 // 转换为毫秒
      const now = Date.now()
      
      // 添加5秒的缓冲时间，避免时间同步问题
      const bufferTime = 5 * 1000 // 5秒
      const isExpired = (exp - now) < bufferTime
      
      return isExpired
    } catch (error) {
      console.error('解析token失败:', error)
      return true
    }
  }
}


